/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var PropTypes = require("prop-types");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./AccountSwitch.css'); }
var moduleClassNameFactory_1 = require("../util/moduleClassNameFactory");
var CompositeDropdown_1 = require("../CompositeDropdown");
var AsyncStateTransformer_1 = require("../AsyncStateTransformer");
var NestedView_1 = require("../NestedView");
var MediaList_1 = require("../MediaList");
var Media_1 = require("../Media");
var Address_1 = require("../Address");
var Navigation_1 = require("../Navigation");
var ProfilePicture_1 = require("../ProfilePicture");
var Badge_1 = require("../Badge");
var Button_1 = require("../Button");
var Icon_1 = require("../Icon");
var objectWithout_1 = require("../util/objectWithout");
var CompanyProfile_1 = require("../CompanyProfile");
var Zzz_1 = require("../Zzz");
var SVGImage_1 = require("../SVGImage");
/* Used for "noBusinessContent" */
var cartImages = {
    makro: require("../../img/metro/accountswitch/makro-cart-image.jpg"),
    metro: require("../../img/metro/accountswitch/metro-cart-image.jpg")
};
/* Used for "serviceUnavailableContent" */
// @ts-ignore false path error
var serviceUnavailableImage = require("../../img/metro/accountswitch/service-unavailable.jpg");
var lockedImage = require("../../img/metro/accountswitch/locked-account.svg");
var disabledProfileColor = "#CCD0D6";
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-accountSwitch");
var accountSwitchShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    abbreviation: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    badgeCount: PropTypes.number,
    color: PropTypes.string.isRequired,
    companyName: PropTypes.string.isRequired,
    validated: PropTypes.bool,
    locked: PropTypes.bool
});
var AccountSwitch = /** @class */ (function (_super) {
    tslib_1.__extends(AccountSwitch, _super);
    function AccountSwitch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isAnimating: false
        };
        _this.running = false;
        _this.isActiveAccountValid = true;
        _this.isActiveAccountLocked = false;
        _this.otherAccountsBadgeTotal = 0;
        _this.showAddBusiness = false;
        return _this;
    }
    AccountSwitch.badgeCountAllButSelected = function (accounts, activeAccount) {
        return Math.max(0, accounts
            .map(function (_a) {
            var badgeCount = _a.badgeCount;
            return badgeCount || 0;
        })
            .reduce(function (sum, badgeCount) { return sum + badgeCount; }, activeAccount && activeAccount.badgeCount
            ? activeAccount.badgeCount * -1
            : 0));
    };
    AccountSwitch.badgeCountAll = function (accounts, person) {
        return accounts.reduce(function (count, account) { return count + (account.badgeCount || 0); }, person.badgeCount || 0);
    };
    AccountSwitch.isValidAccount = function (account) {
        return (!!account &&
            (account.validated === undefined || account.validated === true));
    };
    AccountSwitch.isLockedAccount = function (account) {
        return !!account && !!account.locked;
    };
    AccountSwitch.prototype.componentWillMount = function () {
        this.setComputedProperties();
    };
    AccountSwitch.prototype.componentWillUpdate = function () {
        this.setComputedProperties();
    };
    AccountSwitch.prototype.setComputedProperties = function () {
        var activeAccount = this.props.activeAccount;
        var _a = this.props.actions, joinAccount = _a.joinAccount, addExistingCard = _a.addExistingCard, registerNewAccount = _a.registerNewAccount;
        this.showAddBusiness = !!(joinAccount ||
            addExistingCard ||
            registerNewAccount);
        this.otherAccountsBadgeTotal = AccountSwitch.badgeCountAllButSelected(this.props.accounts, activeAccount);
        if (activeAccount) {
            this.currentActiveAccount = activeAccount;
            this.isActiveAccountValid = AccountSwitch.isValidAccount(activeAccount);
            this.isActiveAccountLocked = AccountSwitch.isLockedAccount(activeAccount);
        }
        else if (this.currentActiveAccount) {
            this.currentActiveAccount = undefined;
            this.isActiveAccountValid = true;
            this.isActiveAccountLocked = false;
        }
    };
    AccountSwitch.prototype.changeAccount = function (account) {
        this.props.onSwitchStart(account);
    };
    AccountSwitch.prototype.accountLinkHTMLProps = function (link) {
        var _this = this;
        return tslib_1.__assign({}, objectWithout_1.objectWithout(link, ["active", "badgeCount", "text"]), { onClick: function (e) {
                var onClick = link.onClick;
                if (onClick) {
                    _this.setState({ secondStep: false });
                    _this.props.onRequestClose();
                    onClick(e);
                }
            } });
    };
    AccountSwitch.prototype.truncatedMail = function (mail, maxLength) {
        if (mail.length > maxLength) {
            var ending = "...";
            var splitMail = mail.split("@");
            return (splitMail[0].substring(0, maxLength - splitMail[1].length - ending.length) +
                ending +
                "@" +
                splitMail[1]);
        }
        else {
            return mail;
        }
    };
    AccountSwitch.prototype.renderServiceUnavailableImage = function () {
        return (React.createElement("img", { className: moduleClassName("serviceUnavailableImage"), src: serviceUnavailableImage, width: 92, height: 131 }));
    };
    AccountSwitch.prototype.renderCartImage = function () {
        var _a = this.props.cartType, cartType = _a === void 0 ? "metro" : _a;
        return (React.createElement("img", { src: cartImages[cartType], className: moduleClassName("noAccountContentImage") }));
    };
    AccountSwitch.prototype.renderPersonProfile = function () {
        var _a = this.props, person = _a.person, actions = _a.actions;
        var profileAndSettingsLinkProps = this.accountLinkHTMLProps(actions.profileAndSettings);
        var logoutLinkProps = this.accountLinkHTMLProps(actions.logout);
        profileAndSettingsLinkProps.className = classnames(profileAndSettingsLinkProps.className, moduleClassName("personProfileLink"));
        logoutLinkProps.className = classnames(logoutLinkProps.className, moduleClassName("personProfileLink"));
        return (React.createElement(Media_1.Media, { className: "m-media-person" },
            React.createElement(Media_1.MediaVisual, null,
                React.createElement(ProfilePicture_1.ProfilePicture, { gender: person.gender, badgeCount: person.badgeCount })),
            React.createElement(Media_1.MediaContent, null,
                React.createElement(Address_1.Address, null,
                    React.createElement("strong", null, person.userName),
                    React.createElement("br", null),
                    React.createElement("a", tslib_1.__assign({}, profileAndSettingsLinkProps), actions.profileAndSettings.text),
                    " – ",
                    React.createElement("a", tslib_1.__assign({}, logoutLinkProps), actions.logout.text)))));
    };
    AccountSwitch.prototype.renderMobileheader = function (animatedState) {
        var _this = this;
        var _a = this.props, person = _a.person, serviceUnavailable = _a.serviceUnavailable;
        var address = animatedState.address, abbreviation = animatedState.abbreviation, badgeCount = animatedState.badgeCount, color = animatedState.color, companyName = animatedState.companyName, validated = animatedState.validated, locked = animatedState.locked;
        return (React.createElement(CompositeDropdown_1.CompositeDropdownHeader, { handleOnClose: function (e) {
                e.preventDefault();
                _this.props.onRequestClose();
            } }, !!companyName ? (React.createElement(CompanyProfile_1.CompanyProfile, { name: companyName, address: address, color: color, abbreviation: abbreviation, badgeCount: badgeCount, validated: validated, locked: locked, mobile: this.props.mobile, header: true })) : (React.createElement(Media_1.Media, { className: "m-media-person" },
            React.createElement(Media_1.MediaVisual, null,
                React.createElement(ProfilePicture_1.ProfilePicture, tslib_1.__assign({ abbreviation: locked ? React.createElement(Icon_1.Icon, { type: "lock" }) : "", serviceUnavailable: serviceUnavailable }, person))),
            React.createElement(Media_1.MediaContent, null,
                React.createElement(Address_1.Address, null,
                    React.createElement("strong", null, person.userName)))))));
    };
    AccountSwitch.prototype.renderNonValidMenuEntry = function (menuEntry) {
        var _this = this;
        var onClick = menuEntry.onClick, text = menuEntry.text, badgeCount = menuEntry.badgeCount, anchorProps = tslib_1.__rest(menuEntry, ["onClick", "text", "badgeCount"]);
        if (onClick) {
            anchorProps.onClick = function (e) {
                _this.setState({ secondStep: false });
                _this.props.onRequestClose();
                onClick(e);
            };
        }
        return (React.createElement("a", tslib_1.__assign({ className: "m-accountSwitch-nonValidLink" }, anchorProps),
            text,
            !!badgeCount && React.createElement(Badge_1.Badge, { count: badgeCount })));
    };
    AccountSwitch.prototype.renderMenuEntry = function (classSuffix, menuEntry) {
        var _this = this;
        var mobile = this.props.mobile;
        var active = menuEntry.active, badgeCount = menuEntry.badgeCount, text = menuEntry.text, onClick = menuEntry.onClick, anchorProps = tslib_1.__rest(menuEntry, ["active", "badgeCount", "text", "onClick"]);
        if (onClick) {
            anchorProps.onClick = function (e) {
                _this.setState({ secondStep: false });
                _this.props.onRequestClose();
                onClick(e);
            };
        }
        return (React.createElement(Navigation_1.NavigationLink, { className: "m-navigation-link-" + classSuffix, mobile: mobile, active: active, key: menuEntry.text },
            React.createElement("a", tslib_1.__assign({}, anchorProps),
                text,
                " ",
                !!badgeCount && React.createElement(Badge_1.Badge, { count: badgeCount }))));
    };
    AccountSwitch.prototype.renderContent = function (animatedState) {
        return this.props.mobile
            ? this.renderMobileContent(animatedState)
            : this.renderDesktopContent(animatedState);
    };
    AccountSwitch.prototype.renderMobileContent = function (animatedState) {
        var _a = this.props, accounts = _a.accounts, person = _a.person, serviceUnavailable = _a.serviceUnavailable;
        if (serviceUnavailable) {
            return this.renderServiceUnavailableMobileContent(animatedState);
        }
        else if (!accounts.length) {
            return this.renderNoAccountMobileContent(animatedState);
        }
        var badgeCountAllButSelected = AccountSwitch.badgeCountAllButSelected(this.props.accounts, this.props.activeAccount);
        if (person.userName.includes("@")) {
            person.userName = this.truncatedMail(person.userName, 28);
        }
        return (React.createElement(NestedView_1.NestedView, null,
            React.createElement(NestedView_1.NestedViewPage, null,
                !this.isActiveAccountValid
                    ? this.renderNonValidContent()
                    : undefined,
                this.isActiveAccountValid && this.isActiveAccountLocked
                    ? this.renderLockedAccountContent()
                    : undefined,
                this.renderNavigation(),
                React.createElement(Media_1.Media, { className: "m-media-person" },
                    React.createElement(Media_1.MediaVisual, null,
                        React.createElement(ProfilePicture_1.ProfilePicture, tslib_1.__assign({}, person))),
                    React.createElement(Media_1.MediaContent, null,
                        React.createElement(Address_1.Address, null,
                            React.createElement("strong", null, person.userName)))),
                this.renderMobileProfileLinks()),
            this.renderSecondStep(animatedState)));
    };
    AccountSwitch.prototype.renderMobileProfileLinks = function () {
        var _a = this.props, actions = _a.actions, mobilePersonalMenuEntries = _a.mobilePersonalMenuEntries;
        return (React.createElement(Navigation_1.Navigation, null,
            !!mobilePersonalMenuEntries &&
                mobilePersonalMenuEntries.length >= 1 && (React.createElement(Navigation_1.NavigationSeparator, { marginless: true })),
            this.renderMobileProfileAndSettingsLink(),
            React.createElement(Navigation_1.NavigationLink, { className: "m-navigation-link-logout", mobile: true },
                React.createElement("a", tslib_1.__assign({}, this.accountLinkHTMLProps(actions.logout)), actions.logout.text))));
    };
    AccountSwitch.prototype.renderMobileProfileAndSettingsLink = function () {
        var _this = this;
        var _a = this.props, actions = _a.actions, person = _a.person, mobilePersonalMenuEntries = _a.mobilePersonalMenuEntries;
        if (mobilePersonalMenuEntries.length > 1) {
            return (React.createElement(Navigation_1.NavigationLink, { className: "m-navigation-link-profileAndSettings", mobile: true, chevron: true },
                React.createElement("a", tslib_1.__assign({}, this.accountLinkHTMLProps(actions.profileAndSettings), { onClick: function (e) {
                        e.preventDefault();
                        _this.setState({
                            secondStep: "mobileProfileSettings"
                        });
                    } }),
                    actions.profileAndSettings.text,
                    " ",
                    !!person.badgeCount && React.createElement(Badge_1.Badge, { count: person.badgeCount }))));
        }
        else if (mobilePersonalMenuEntries.length === 1) {
            var menuEntry = mobilePersonalMenuEntries[0];
            return (React.createElement(Navigation_1.NavigationLink, { className: "m-navigation-link-profileAndSettings", mobile: true },
                React.createElement("a", tslib_1.__assign({}, this.accountLinkHTMLProps(menuEntry)),
                    menuEntry.text,
                    !!menuEntry.badgeCount && React.createElement(Badge_1.Badge, { count: menuEntry.badgeCount }))));
        }
        return null;
    };
    AccountSwitch.prototype.renderServiceUnavailableMobileContent = function (animatedState) {
        return (React.createElement(NestedView_1.NestedView, null,
            React.createElement(NestedView_1.NestedViewPage, null,
                React.createElement(Media_1.Media, null,
                    React.createElement(Media_1.MediaContent, null,
                        React.createElement("div", { className: "centered" },
                            this.renderServiceUnavailableImage(),
                            this.props.serviceUnavailableContent))))));
    };
    AccountSwitch.prototype.renderNoAccountMobileContent = function (animatedState) {
        var _a = this.props.actions, joinAccount = _a.joinAccount, addExistingCard = _a.addExistingCard, registerNewAccount = _a.registerNewAccount;
        return (React.createElement(NestedView_1.NestedView, null,
            React.createElement(NestedView_1.NestedViewPage, null,
                this.renderMobileProfileLinks(),
                this.showAddBusiness && (React.createElement(Media_1.Media, { className: moduleClassName("noAccountContentMedia") },
                    React.createElement(Media_1.MediaContent, null,
                        React.createElement("div", { className: moduleClassName("noAccountContent") },
                            this.renderCartImage(),
                            this.props.noAccountContent,
                            addExistingCard && (React.createElement(Button_1.Button, tslib_1.__assign({ TagName: "a", kind: "primary", className: "m-button-addExistingCard", block: true }, this.accountLinkHTMLProps(addExistingCard)), addExistingCard.text)),
                            registerNewAccount && (React.createElement(Button_1.Button, tslib_1.__assign({ TagName: "a", kind: addExistingCard ? "secondary" : "primary", className: "m-button-registerNewAccount", block: true }, this.accountLinkHTMLProps(registerNewAccount)), registerNewAccount.text)),
                            joinAccount && (React.createElement(Button_1.Button, tslib_1.__assign({ TagName: "a", kind: addExistingCard || registerNewAccount
                                    ? "secondary"
                                    : "primary", className: "m-button-joinAccount", block: true }, this.accountLinkHTMLProps(joinAccount)), joinAccount.text))))))),
            this.renderSecondStep(animatedState)));
    };
    AccountSwitch.prototype.renderDesktopContent = function (animatedState) {
        var _a = this.props, accounts = _a.accounts, serviceUnavailable = _a.serviceUnavailable;
        if (serviceUnavailable) {
            return this.renderServiceUnavailableDesktopContent();
        }
        else if (!accounts.length) {
            return this.renderNoAccountDesktopContent();
        }
        return (React.createElement(NestedView_1.NestedView, null,
            React.createElement(NestedView_1.NestedViewPage, null,
                React.createElement(MediaList_1.MediaList, null,
                    this.renderPersonProfile(),
                    animatedState.companyName && (React.createElement(CompanyProfile_1.CompanyProfile, { name: animatedState.companyName, address: animatedState.address, color: animatedState.color, abbreviation: animatedState.abbreviation, badgeCount: animatedState.badgeCount, validated: animatedState.validated, locked: animatedState.locked, mobile: this.props.mobile }))),
                !this.isActiveAccountValid
                    ? this.renderNonValidContent()
                    : undefined,
                this.isActiveAccountValid && this.isActiveAccountLocked
                    ? this.renderLockedAccountContent()
                    : undefined,
                this.renderNavigation()),
            this.renderSecondStep(animatedState)));
    };
    AccountSwitch.prototype.renderNonValidContent = function () {
        var actions = this.props.actions;
        return (React.createElement(Media_1.Media, { className: "m-accountSwitch-nonValidContent" },
            React.createElement(Media_1.MediaContent, null,
                React.createElement("div", { className: "centered" },
                    React.createElement(Zzz_1.Zzz, null),
                    this.props.nonValidatedAccountContent,
                    actions.findNearestStore && (React.createElement(Button_1.Button, tslib_1.__assign({ TagName: "a", kind: "primary", className: "m-button-findNearestStore", block: true }, this.accountLinkHTMLProps(actions.findNearestStore)),
                        actions.findNearestStore.text,
                        React.createElement(Icon_1.Icon, { type: "launch" })))))));
    };
    AccountSwitch.prototype.renderLockedAccountContent = function () {
        var actions = this.props.actions;
        return (React.createElement(Media_1.Media, { className: "m-accountSwitch-nonValidContent" },
            React.createElement(Media_1.MediaContent, null,
                React.createElement("div", { className: "centered" },
                    React.createElement(SVGImage_1.SVGImage, { src: lockedImage }),
                    this.props.lockedAccountContent,
                    actions.enterActivationCode && (React.createElement(Button_1.Button, tslib_1.__assign({ TagName: "a", kind: "primary", className: "m-button-findNearestStore", block: true }, this.accountLinkHTMLProps(actions.enterActivationCode)), actions.enterActivationCode.text))))));
    };
    AccountSwitch.prototype.renderMenu = function () {
        var _this = this;
        var toplevelMenuEntries = this.props.toplevelMenuEntries;
        if (this.isActiveAccountValid && !this.isActiveAccountLocked) {
            return toplevelMenuEntries.map(function (entry, index) { return (React.createElement(React.Fragment, { key: index }, _this.renderMenuEntry("toplevel", entry))); });
        }
        if (toplevelMenuEntries.length > 0) {
            return (React.createElement("div", null, toplevelMenuEntries.map(function (entry, index) { return (React.createElement(React.Fragment, { key: index }, _this.renderNonValidMenuEntry(entry))); })));
        }
        return null;
    };
    AccountSwitch.prototype.renderNavigation = function () {
        var _this = this;
        var _a = this.props, accounts = _a.accounts, labels = _a.labels, toplevelMenuEntries = _a.toplevelMenuEntries, mobile = _a.mobile;
        return (React.createElement(Navigation_1.Navigation, null,
            this.renderMenu(),
            !mobile &&
                toplevelMenuEntries.length > 0 &&
                (accounts.length > 1 || this.showAddBusiness) && (React.createElement(Navigation_1.NavigationSeparator, null)),
            mobile &&
                (!this.isActiveAccountValid || this.isActiveAccountLocked) && (React.createElement(Navigation_1.NavigationSeparator, { marginless: true })),
            accounts.length > 1 && (React.createElement(Navigation_1.NavigationLink, { className: "m-navigation-link-switchAccount", icon: "swap-business-small", chevron: true, mobile: mobile },
                React.createElement("a", { title: labels.switchAccount.title, onClick: function () { return _this.setState({ secondStep: "switchAccount" }); } },
                    labels.switchAccount.text,
                    " ",
                    !!this.otherAccountsBadgeTotal && (React.createElement(Badge_1.Badge, { count: this.otherAccountsBadgeTotal }))))),
            this.showAddBusiness && this.renderAddBusinessAccountLink()));
    };
    AccountSwitch.prototype.renderAddBusinessAccountLink = function () {
        var _this = this;
        var _a = this.props, labels = _a.labels, actions = _a.actions, mobile = _a.mobile;
        var actionsList = [
            actions.addExistingCard ? actions.addExistingCard : null,
            actions.registerNewAccount ? actions.registerNewAccount : null,
            actions.joinAccount ? actions.joinAccount : null
        ].filter(function (elem) { return elem !== null; });
        if (actionsList.length > 1) {
            return (React.createElement(Navigation_1.NavigationLink, { className: "m-navigation-link-addAccount", icon: "add", chevron: true, mobile: mobile },
                React.createElement("a", { title: labels.addAccount.title, onClick: function () { return _this.setState({ secondStep: "addAccount" }); } }, labels.addAccount.text)));
        }
        else if (actionsList.length === 1) {
            var action = actionsList[0];
            return (React.createElement(Navigation_1.NavigationLink, { className: "m-navigation-link-addAccount", icon: "add", mobile: mobile },
                React.createElement("a", tslib_1.__assign({}, this.accountLinkHTMLProps(action)), action.text)));
        }
        return null;
    };
    AccountSwitch.prototype.renderServiceUnavailableDesktopContent = function () {
        return (React.createElement(NestedView_1.NestedView, null,
            React.createElement(NestedView_1.NestedViewPage, null,
                React.createElement(Media_1.Media, null,
                    React.createElement(Media_1.MediaContent, null,
                        React.createElement("div", { className: "centered" },
                            this.renderServiceUnavailableImage(),
                            this.props.serviceUnavailableContent))))));
    };
    AccountSwitch.prototype.renderNoAccountDesktopContent = function () {
        var _a = this.props.actions, joinAccount = _a.joinAccount, addExistingCard = _a.addExistingCard, registerNewAccount = _a.registerNewAccount;
        if (this.showAddBusiness) {
            return (React.createElement(NestedView_1.NestedView, null,
                React.createElement(NestedView_1.NestedViewPage, null,
                    React.createElement(MediaList_1.MediaList, null, this.renderPersonProfile()),
                    React.createElement(Media_1.Media, { className: moduleClassName("noAccountContentMedia") },
                        React.createElement(Media_1.MediaContent, null,
                            React.createElement("div", { className: moduleClassName("noAccountContent") },
                                this.renderCartImage(),
                                this.props.noAccountContent,
                                addExistingCard && (React.createElement(Button_1.Button, tslib_1.__assign({ TagName: "a", kind: "primary", className: "m-button-addExistingCard", block: true }, this.accountLinkHTMLProps(addExistingCard)), addExistingCard.text)),
                                registerNewAccount && (React.createElement(Button_1.Button, tslib_1.__assign({ TagName: "a", kind: addExistingCard ? "secondary" : "primary", className: "m-button-registerNewAccount", block: true }, this.accountLinkHTMLProps(registerNewAccount)), registerNewAccount.text)),
                                joinAccount && (React.createElement(Button_1.Button, tslib_1.__assign({ TagName: "a", kind: addExistingCard || registerNewAccount
                                        ? "secondary"
                                        : "primary", className: "m-button-joinAccount", block: true }, this.accountLinkHTMLProps(joinAccount)), joinAccount.text))))))));
        }
        return React.createElement(MediaList_1.MediaList, null, this.renderPersonProfile());
    };
    AccountSwitch.prototype.renderSecondStep = function (animatedState) {
        var _this = this;
        var _a = this.props, accounts = _a.accounts, actions = _a.actions, mobile = _a.mobile, labels = _a.labels;
        switch (this.state.secondStep) {
            case "addAccount":
                return (React.createElement(NestedView_1.NestedViewPage, { className: "m-nestedView-page-" + this.state.secondStep },
                    React.createElement(Navigation_1.Navigation, null,
                        React.createElement(Navigation_1.NavigationLink, { back: true, icon: "arrow-left" },
                            React.createElement("a", { onClick: function () { return _this.setState({ secondStep: false }); } }, labels.back.text)),
                        actions.addExistingCard && (React.createElement(Navigation_1.NavigationLink, { mobile: mobile },
                            React.createElement("a", tslib_1.__assign({}, this.accountLinkHTMLProps(actions.addExistingCard)), actions.addExistingCard.text))),
                        actions.registerNewAccount && (React.createElement(Navigation_1.NavigationLink, { mobile: mobile },
                            React.createElement("a", tslib_1.__assign({}, this.accountLinkHTMLProps(actions.registerNewAccount)), actions.registerNewAccount.text))),
                        actions.joinAccount && (React.createElement(Navigation_1.NavigationLink, { mobile: mobile },
                            React.createElement("a", tslib_1.__assign({}, this.accountLinkHTMLProps(actions.joinAccount)), actions.joinAccount.text))))));
            case "switchAccount":
                return (React.createElement(NestedView_1.NestedViewPage, { className: "m-nestedView-page-" + this.state.secondStep },
                    React.createElement(Navigation_1.Navigation, null,
                        React.createElement(Navigation_1.NavigationLink, { back: true, icon: "arrow-left" },
                            React.createElement("a", { onClick: function () { return _this.setState({ secondStep: false }); } }, labels.back.text))),
                    React.createElement(MediaList_1.MediaList, null, accounts.map(function (account) { return (React.createElement(CompanyProfile_1.CompanyProfile, { key: account.id, onClick: animatedState.id === account.id
                            ? undefined
                            : function (e) {
                                e.preventDefault();
                                _this.changeAccount(account);
                            }, color: account.color, abbreviation: account.abbreviation, badgeCount: account.badgeCount, name: account.companyName, address: account.address, selected: animatedState.id === account.id, validated: account.validated, locked: account.locked, mobile: _this.props.mobile })); }))));
            case "mobileProfileSettings":
                return (React.createElement(NestedView_1.NestedViewPage, { className: "m-nestedView-page-" + this.state.secondStep },
                    React.createElement(Navigation_1.Navigation, null,
                        React.createElement(Navigation_1.NavigationLink, { back: true, icon: "arrow-left" },
                            React.createElement("a", { onClick: function () { return _this.setState({ secondStep: false }); } }, labels.back.text)),
                        this.props.mobilePersonalMenuEntries.map(function (entry, index) { return (React.createElement(React.Fragment, { key: index }, _this.renderMenuEntry("personal", entry))); }))));
            default:
                return null;
        }
    };
    AccountSwitch.prototype.render = function () {
        var _this = this;
        var _a = this.props, serviceUnavailable = _a.serviceUnavailable, active = _a.active, activeAccount = _a.activeAccount, accounts = _a.accounts, person = _a.person, className = _a.className, mobile = _a.mobile;
        this.running =
            this.running ||
                (!!this.currentActiveAccount &&
                    this.currentActiveAccount !== activeAccount);
        var initialState = tslib_1.__assign({ secondStep: this.state.secondStep }, activeAccount);
        var locked = this.isActiveAccountLocked;
        if (person.userName.includes("@")) {
            person.userName = this.truncatedMail(person.userName, 28);
        }
        return (React.createElement(AsyncStateTransformer_1.AsyncStateTransformer, { running: this.running, steps: [
                {
                    minimumDuration: 500,
                    state: {
                        showSpinner: true,
                        badgeCount: 0,
                        companyName: ""
                    }
                },
                {
                    minimumDuration: 1500,
                    state: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        var abbreviation, companyName, color, validated, locked_1;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, AsyncStateTransformer_1.AsyncStateTransformer.asyncTimeout(1000)];
                                case 1:
                                    _a.sent();
                                    if (activeAccount) {
                                        abbreviation = activeAccount.abbreviation, companyName = activeAccount.companyName, color = activeAccount.color, validated = activeAccount.validated, locked_1 = activeAccount.locked;
                                        return [2 /*return*/, {
                                                showSpinner: false,
                                                companyName: companyName,
                                                abbreviation: abbreviation,
                                                color: color,
                                                validated: validated,
                                                locked: locked_1
                                            }];
                                    }
                                    return [2 /*return*/, {
                                            showSpinner: false
                                        }];
                            }
                        });
                    }); }
                },
                {
                    state: {
                        secondStep: false
                    }
                },
                {
                    minimumDuration: 600,
                    state: function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            return [2 /*return*/, ({
                                    badgeCount: activeAccount.badgeCount,
                                    validated: activeAccount.validated,
                                    locked: activeAccount.locked,
                                    color: activeAccount.color
                                })];
                        });
                    }); }
                }
            ], initialState: initialState, onDone: function (finalState) {
                _this.running = false;
                _this.setState(tslib_1.__assign({}, finalState));
            }, onError: function (err) {
                _this.running = false;
                _this.setState({
                    error: err.message || "something went wrong"
                });
            } }, function (_a) {
            var secondStep = _a.secondStep, animatedState = tslib_1.__rest(_a, ["secondStep"]);
            var _b;
            return (React.createElement(CompositeDropdown_1.CompositeDropdown, tslib_1.__assign({ serviceUnavailable: serviceUnavailable, active: active, mobile: mobile, onClick: function () { return _this.props.onClick(active); }, onRequestClose: function () { return _this.props.onRequestClose(); } }, _this.props.person, animatedState, { color: AccountSwitch.isValidAccount(animatedState)
                    ? animatedState.color
                    : disabledProfileColor, header: mobile ? _this.renderMobileheader(animatedState) : undefined, abbreviation: animatedState.locked &&
                    (animatedState.validated === undefined ||
                        !!animatedState.validated) ? (React.createElement(Icon_1.Icon, { type: "lock", size: 0.8125 })) : (animatedState.abbreviation), badgeCount: AccountSwitch.badgeCountAll(accounts, person), className: classnames(moduleClassName(), className, (_b = {},
                    _b[moduleClassName("mobile")] = mobile,
                    _b)) }), _this.renderContent(tslib_1.__assign({ secondStep: secondStep }, animatedState))));
        }));
    };
    AccountSwitch.propTypes = {
        /* General */
        serviceUnavailable: PropTypes.bool,
        active: PropTypes.bool.isRequired,
        className: PropTypes.string,
        mobile: PropTypes.bool.isRequired,
        cartType: PropTypes.oneOf(["metro", "makro"]),
        /* Person */
        person: PropTypes.shape({
            badgeCount: PropTypes.number,
            gender: ProfilePicture_1.ProfilePicture.propTypes.gender,
            userName: PropTypes.string.isRequired
        }),
        /* Account Data */
        activeAccount: accountSwitchShape,
        accounts: PropTypes.arrayOf(accountSwitchShape).isRequired,
        /* eventHandlers */
        onClick: PropTypes.func.isRequired,
        onRequestClose: PropTypes.func.isRequired,
        onSwitchStart: PropTypes.func.isRequired,
        onSwitchFinish: PropTypes.func.isRequired,
        /* Fix Content */
        serviceUnavailableContent: PropTypes.element,
        noAccountContent: PropTypes.element,
        /* Navigation */
        actions: PropTypes.shape({
            addExistingCard: PropTypes.object,
            registerNewAccount: PropTypes.object,
            joinAccount: PropTypes.object,
            profileAndSettings: PropTypes.object.isRequired,
            logout: PropTypes.object.isRequired
        }).isRequired,
        labels: PropTypes.shape({
            addAccount: PropTypes.object.isRequired,
            switchAccount: PropTypes.object.isRequired
        }).isRequired,
        toplevelMenuEntries: PropTypes.arrayOf(PropTypes.object).isRequired,
        mobilePersonalMenuEntries: PropTypes.arrayOf(PropTypes.object).isRequired
    };
    return AccountSwitch;
}(React.Component));
exports.AccountSwitch = AccountSwitch;